import React from 'react';

/**
 * ChipSelect — multi-select chip group.
 * @param {string}   label    - Field label text
 * @param {string[]} options  - Array of option strings
 * @param {string[]} selected - Currently selected values
 * @param {function} onChange - Called with new selected array
 * @param {boolean}  required - Show required star
 */
function ChipSelect({ label, options, selected = [], onChange, required }) {
  function toggle(option) {
    if (selected.includes(option)) {
      onChange(selected.filter((v) => v !== option));
    } else {
      onChange([...selected, option]);
    }
  }

  return (
    <div className="field-group">
      {label && (
        <label className="field-label">
          {label}
          {required && <span className="required-star">*</span>}
        </label>
      )}
      <div className="chip-group" role="group" aria-label={label}>
        {options.map((option) => (
          <button
            key={option}
            type="button"
            className={`chip${selected.includes(option) ? ' selected' : ''}`}
            onClick={() => toggle(option)}
            aria-pressed={selected.includes(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ChipSelect;
